export function filterCategories(categories, searchTerm) {
  if (!searchTerm || !searchTerm.trim()) return categories;

  const lowerTerm = searchTerm.trim().toLowerCase();

  return categories
    .filter(category => {
      // Check if parent matches
      const parentMatch = category.name.toLowerCase().includes(lowerTerm);
      if (parentMatch) return true;

      // If no children, skip this category
      if (!category.children || category.children.length === 0) return false;

      // Check if a child/subcategory matches
      const matchingChildren = category.children.find(child =>
        child.name.toLowerCase().includes(lowerTerm)
      );
      if (!!matchingChildren) return true;

      return false;
    })
}
